import React from "react";
import './styles.css';



  


function Navhovgal(){

    return (
        <>
            <li>
                <span className="link">
                    <span className="word">
                        <span className="char" data-char="g" style={{"--charIndex": 0 }}>g</span>
                        <span className="char" data-char="a" style={{"--charIndex": 1 }}>a</span>
                        <span className="char" data-char="l" style={{"--charIndex": 2 }}>l</span>
                        <span className="char" data-char="l" style={{"--charIndex": 3 }}>l</span>
                        <span className="char" data-char="e" style={{"--charIndex": 4 }}>e</span>
                        <span className="char" data-char="r" style={{"--charIndex": 5 }}>r</span>
                        <span className="char" data-char="y" style={{"--charIndex": 6 }}>y</span>
                    </span>
                </span>
                    
            </li>
        </>
        
    )
}

export default Navhovgal;